'use strict';

class DevicesListController {
  constructor($q,
              $scope,
              $filter,
              $state,
              utils,
              VirtualPaginator,
              DevicesService,
              TagsService,
              PermissionsService,
              ToastsService) {

    // #region Define fields

    const $t = $filter('translate');
    const ORGANIZATIONS_LOCAL_STORAGE_KEY = 'Organizations-All';
    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
    const SELECTED_LOCATION_LOCAL_STORAGE_KEY = 'Selected-Location';
    const SELECTED_DEVICE_LOCAL_STORAGE_KEY = 'Selected-Device';
    const REQUEST_LIMIT = 100;

    $scope.devicesPage = {};
    $scope.isOpeningUrl = false;
    $scope.timeFormatStr = $t('datetime.mdyHM12');

    let $page = $scope.devicesPage;

    $page.orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
    $page.allOrgs = utils.getStorageItem(ORGANIZATIONS_LOCAL_STORAGE_KEY);

    $page.updateBtnDesc = $t('groups.btn.new-desc');
    $page.updateBtnText = $t('btn.add');

    $page.searchVal = '';
    $page.loading = false;
    $scope.thereAreMoreItems = false;
    $page.deviceStatuses = [
      {
        'id': '1',
        'name': $t('devices.status.all')
      }, {
        'id': '2',
        'name': $t('devices.status.connected')
      }, {
        'id': '3',
        'name': $t('devices.status.disconnected')
      }, {
        'id': '4',
        'name': $t('devices.status.notInstalled')
      }
    ];

    let filterKey = 'Filter-Devices-' + $page.orgInfo.id;
    $scope.cacheFilter = false;

    // Batch editing fields
    $scope.isSelectMode = false;
    $scope.isSelectModeClickCount = 0;
    $scope.selectedDevices = [];

    // #endregion

    // #region Put on scope only the stuff we really need there
    angular.extend($scope, {
      isFilterDirty: isFilterDirty,

      // Filtering stuff
      toggleFilter: toggleFilter,
      toggleSearchWild: toggleSearchWild,
      toggleSearchById: toggleSearchById,
      closeFilter: closeFilter,
      saveFilter: saveFilter,
      initFilterFromCache: initFilterFromCache,
      filterDevices: filterDevices,
      resetFilters: resetFilters,
      filterByTag: filterByTag,

      stopPropagation: stopPropagation,
      debugDevice: debugDevice,
      showMoreTags: showMoreTags,
      hasFeature: hasFeature,
      generateAddress: generateAddress,
      deleteDevice: deleteDevice,
      goToLocation: goToLocation,

      canEditDevice: canEditDevice,
      canDeleteDevice: canDeleteDevice,
      canEditDeviceLocation: canEditDeviceLocation,
      canCreateDevice: canCreateDevice,

      // Batch editing related
      toggleSelectionMode: toggleSelectionMode,
      toggleDeviceSelection: toggleDeviceSelection,
      isSelected: isSelected,
      toggleBatchEditPanel: toggleBatchEditPanel,
      closeBatchEditPanel: closeBatchEditPanel,
      onBatchApplyButtonClick: onBatchApplyButtonClick,
    });

    // Remove modals
    $scope.$on('$destroy', () => {
      $('#delete-device-dialog').remove();
    });

    // #endregion

    // Run initialization routine
    init();

    // #region Methods

    function init() {
      initFilterFromCache();
      initBatchEditPanel();

      $q.all([
        DevicesService.getDeviceTypes(),
        TagsService.getPopularTags($page.orgInfo.id, 3),
      ]).then(data => {
        let deviceTypesResult = data[0];
        let tagsResult = data[1];

        // Init tags
        $page.tags = tagsResult.tags || [];

        // Init types
        if (deviceTypesResult.deviceTypes) {
          $page.deviceTypes = {};
          deviceTypesResult.deviceTypes.forEach(function(type) {
            $page.deviceTypes[type.id] = type;
          });
        }

        // Init device type filter
        $scope.allowedDeviceTypes = utils.getOrgAllowedDeviceTypes(deviceTypesResult.deviceTypes, null, $page.orgInfo);

        // Create paginator
        $scope.paginator = new VirtualPaginator(getDevices);

        // Get child organizations if they are exist
        $scope.childOrgs = !$page.orgInfo.parentId ? utils.getChildOrganizations($page.allOrgs, $page.orgInfo.id) : [];
      })
        .catch(err => {
          $page.loading = false;
          $scope.thereAreMoreItems = false;
          utils.handleApiError(err);
        });
    }

    // #region Filter functions

    function isFilterDirty() {
      return !!$page.selectedChildOrgId ||
        !!($page.selectedDeviceTagStrs && $page.selectedDeviceTagStrs.length > 0) ||
        !!($page.selectedDeviceTypeIds && $page.selectedDeviceTypeIds.length > 0);
    }

    function toggleFilter() {
      $('#filter').transition('fade down');
    }

    function toggleSearchWild() {
      $scope.searchWild = !$scope.searchWild;
      $scope.searchById = false;
      resetBatchEditFormValues();
      closeBatchEditPanel();
      toggleSelectionMode(true);

      if ($scope.searchWild) {
        $page.selectedChildOrgId = void 0;
        $page.selectedChildOrg = void 0;
      }
      filterDevices();
    }

    function toggleSearchById() {
      $scope.searchById = !$scope.searchById;
      $scope.searchWild = false;
      resetBatchEditFormValues();
      closeBatchEditPanel();
      toggleSelectionMode(true);
      resetFilters();

      if ($scope.searchById) {
        $page.selectedChildOrgId = void 0;
        $page.selectedChildOrg = void 0;
      }
    }

    function closeFilter() {
      let visible = $('#filter').transition('is visible');
      if (visible) {
        $('#filter').transition('hide');
      }
    }

    function saveFilter() {
      if ($scope.cacheFilter) { // Cache filter
        let params = {
          searchVal: $scope.searchVal,
          selectedChildOrgId: $page.selectedChildOrgId,
          searchWild: $scope.searchWild,
          searchById: $scope.searchById,
        };
        if ($scope.devicesParams) {
          angular.merge(params, {
            selectedDeviceTypeIds: $scope.devicesParams.deviceType,
            selectedDeviceTagStrs: $scope.devicesParams.searchTag
          });
        }
        utils.setStorageItem(filterKey, params);
      } else { // Remove filter
        utils.removeStorageItem(filterKey);
      }
    }

    function initFilterFromCache() {
      $scope.cacheFilter = true;
      let params = utils.getStorageItem(filterKey);
      if (params) {
        $page.selectedDeviceTypeIds = params.selectedDeviceTypeIds;
        $page.selectedChildOrgId = params.selectedChildOrgId;
        $page.selectedDeviceTagStrs = params.selectedDeviceTagStrs;
        $scope.searchVal = params.searchVal;
        $scope.searchWild = params.searchWild;
        $scope.searchById = params.searchById;
      }
    }

    function filterDevices(toggleFilterPanel) {
      if (toggleFilterPanel) {
        toggleFilter();
      }
      if ($scope.paginator) {
        saveFilter();
        $scope.paginator.reload();
      }
    }

    function resetFilters() {
      $scope.thereAreMoreItems = false;
      $page.selectedDeviceTags = void 0;
      $page.selectedDeviceTagStrs = void 0;
      $page.selectedDeviceTypeIds = void 0;
      $page.selectedDeviceTypes = void 0;
      $page.selectedChildOrgId = void 0;
      $page.selectedChildOrg = void 0;
      filterDevices();
    }

    function filterByTag($event, tag) {
      $event.stopPropagation();
      $page.selectedDeviceTagStrs = tag.tag;
      filterDevices();
    }

    // #endregion

    function stopPropagation($event) {
      $event.stopPropagation();
    }

    function canEditDevice(device) {
      return PermissionsService.canIEditDevice(device);
    }

    function canDeleteDevice(device) {
      return PermissionsService.canIDeleteDevice(device);
    }

    function canEditDeviceLocation(device) {
      return PermissionsService.canIEditLocation(device.location);
    }

    function canCreateDevice() {
      return PermissionsService.canICreateDevice();
    }

    function debugDevice(device) {
      // Just select device for edit if we are in the 'select devices' mode.
      if ($scope.isSelectMode) {
        if (canEditDevice(device)) {
          toggleDeviceSelection(device);
        }
        return;
      }

      if (!canEditDevice(device)) {
        return;
      }
      gotoDebugPage(device);
    }

    function showMoreTags($event, device) {
      gotoDebugPage(device);
    }

    function hasFeature(feature) {
      return utils.hasFeature($page.orgInfo, feature);
    }

    function generateAddress(location) {
      let address = utils.generateAddress(location);
      return address === '' ? $t('common.unknown-address') : address;
    }

    function deleteDevice(device) {
      $('#delete-device-dialog')
        .modal({
          closable: true,
          detachable: true,
          onApprove: function() {
            deleteDeviceInternal(device);
          }
        }).modal('show');
    }

    function getParametersForGetDeviceCall() {
      let params = {};
      if ($scope.searchVal) {
        if ($scope.searchById) {
          params.deviceId = $scope.searchVal;
        } else {
          params.searchBy = '*' + $scope.searchVal + '*';
        }
      }
      if ($page.selectedDeviceTypeIds && $page.selectedDeviceTypeIds.length > 0) {
        params.deviceType = $page.selectedDeviceTypeIds;
      }
      if ($page.selectedDeviceTagStrs && $page.selectedDeviceTagStrs.length > 0) {
        params.searchTag = $page.selectedDeviceTagStrs;
      }

      // Always limit requests
      params.limit = REQUEST_LIMIT;
      params.sortBy = 'startDate';
      params.sortOrder = 'desc';

      return params;
    }

    function getDevices() {
      $page.loading = true;
      $scope.devicesParams = getParametersForGetDeviceCall();
      $scope.saveFilter();

      let organizationId = $scope.searchWild || $scope.searchById ? undefined : ($page.selectedChildOrgId || $page.orgInfo.id);

      return DevicesService.getDevicesByParams(organizationId, $scope.devicesParams)
        .then(data => {
          $page.loading = false;
          if (!data.devices) {
            $scope.thereAreMoreItems = false;
            return;
          }

          // #region Process devices
          data.devices = data.devices
            .filter(device => {
              // Check for type availability
              let deviceType = $page.deviceTypes[device.type];
              if (!deviceType) {
                return false;
              }
              // Exclude "nonOrganization" device types (device types that was "hidden" by server)
              // SEE comments in CC-753
              if (deviceType.attributes && deviceType.attributes.some(a => a.name === 'nonOrganization' && a.value === '1')) {
                return false;
              }

              return true;
            });

          for (let device of data.devices) {
            let type = $page.deviceTypes[device.type];

            utils.appendAttr2DeviceType(type);
            let typeName = type ? type.name : null;
            device.deviceListIcon = type.deviceListIcon;
            device.typeDesc = typeName;
            device.dConnected = device.connected;
            device.dDesc = device.desc;
            device.dId = device.id;
            device.dType = device.type;
            device.dTypeIcon = type.iconUrl;
            device.dCategory = device.typeCategory;
            if (device.user) {
              device.userId = device.user.id;
              device.firstname = device.user.firstName;
              device.lastname = device.user.lastName;
              device.email = (device.user.email && device.user.email.email) ? device.user.email.email : null;
              device.phone = device.user.phone;
            }
            if (device.location) {
              device.locationDesc = device.location.name;
            }
            device.deviceTags = device.tags || [];
          }
          // #endregion

          // Limiting request message
          $scope.thereAreMoreItems = data.collectionTotalSize && data.collectionTotalSize === REQUEST_LIMIT;

          return data.devices;
        }, err => {
          $page.loading = false;
          $scope.thereAreMoreItems = false;
          utils.handleApiError(err);
          return $q.reject(err);
        });
    }

    function deleteDeviceInternal(device) {
      if (!device) {
        ToastsService.error($t('devices.errors.not-specified'));
        return;
      }
      if (!device.location) {
        ToastsService.error($t('devices.errors.device-location-absent'));
        return;
      }

      return DevicesService.deleteDevice(device.location.id, device.id)
        .then(() => {
          ToastsService.success(null, $t('common.delete-device-success'));
          $scope.paginator.items = $scope.paginator.items.filter(d => d.id !== device.id);
        });
    }

    function gotoDebugPage(device, tabName) {
      utils.setStorageItem(SELECTED_DEVICE_LOCAL_STORAGE_KEY, device);
      $state.go('main.devices.edit', { tab: tabName, locationId: device.location.id, deviceId: device.id });
    }

    // #endregion

    function goToLocation(location) {
      if (!location || !location.id) {
        return;
      }
      utils.setStorageItem(SELECTED_LOCATION_LOCAL_STORAGE_KEY, location);
      $state.go('main.locations.edit', {
        from: 'devices'
      });
    }

    // #region Batch Editing Methods

    function initBatchEditPanel() {
      $scope.$watchGroup(['selectedDevices', 'selectedTagsForBatchEdit'], () => {
        if (!$scope.selectedDevices || $scope.selectedDevices.length === 0) {
          $scope.canBatchEditTags = false;
          $scope.batchEditTagsMsg = '';
          $scope.isBatchEditApplyEnabled = false;
          return;
        }

        $scope.canBatchEditTags = true;
        $scope.batchEditTagsMsg = '';

        $scope.isBatchEditApplyEnabled = !!$scope.selectedDevices
          && $scope.selectedDevices.length > 0
          && $scope.canBatchEditTags
          && !!$scope.selectedTagsForBatchEdit
          && $scope.selectedTagsForBatchEdit.length > 0;
      }, true);
    }

    function toggleSelectionMode(resetToDefault) {
      if (!$scope.isSelectMode) {
        $scope.isSelectMode = true; //just turn it on
      }
      $scope.isSelectModeClickCount++;

      // To allow to select all via second click, we need to 'switch off' selection mode only on the third click
      if ($scope.isSelectModeClickCount === 2) {
        $scope.selectedDevices = [].concat($scope.paginator.currentPageItems);
      }
      if (resetToDefault || $scope.isSelectModeClickCount === 3) {
        $scope.isSelectMode = false;
        $scope.isSelectModeClickCount = 0;
        if ($('#batchEdit').hasClass('visible')) {
          $scope.toggleBatchEditPanel();
        }
      }

      if (!$scope.isSelectMode) {
        //after we switched off the selection mode
        $scope.selectedDevices.length = 0; //clearing the array of selected devices keeping the reference intact
      }
    }

    function toggleDeviceSelection(device, event) {
      if (!$scope.selectedDevices) {
        $scope.selectedDevices = [];
      }
      let currentDevices = angular.copy($scope.selectedDevices);
      if (isSelected(device)) {
        $scope.selectedDevices = currentDevices.filter(l => l.id !== device.id);
      } else {
        currentDevices.push(device);
        $scope.selectedDevices = currentDevices;
      }
      if (event) {
        event.stopPropagation();
      }
    }

    function isSelected(device) {
      return $scope.selectedDevices.some((u, i) => u.id === device.id);
    }

    function toggleBatchEditPanel() {
      $('#batchEdit').transition('fade down');
    }

    function closeBatchEditPanel() {
      let opened = $('#batchEdit').transition('is visible');
      if (opened) {
        $('#batchEdit').transition('hide');
      }
    }

    function onBatchApplyButtonClick() {
      if ($scope.loading || !$scope.isBatchEditApplyEnabled || !$scope.selectedDevices || $scope.selectedDevices.length === 0) {
        return;
      }

      $('#batch-edit-device-dialog')
        .modal({
          closable: false,
          detachable: true,
          onApprove: function() {
            $scope.$applyAsync(() => {
              updateSelectedDevices();
            });
          }
        }).modal('show');
    }

    function updateSelectedDevices() {
      if ($scope.loading || !$scope.isBatchEditApplyEnabled || !$scope.selectedDevices || $scope.selectedDevices.length === 0) {
        return;
      }

      $scope.loading = true;
      if ($scope.selectedTagsForBatchEdit && $scope.selectedTagsForBatchEdit.length > 0 && $scope.canBatchEditTags) {

        const tagsToApply = [];
        $scope.selectedDevices.forEach(device => {
          $scope.selectedTagsForBatchEdit.forEach(tag => {
            tagsToApply.push({
              type: 3,
              tag: tag,
              id: device.id
            });
          });
        });

        return TagsService.saveTags($page.orgInfo.id, tagsToApply)
          .then(() => {
            $scope.loading = false;
            resetBatchEditFormValues();
            ToastsService.success(null, $t('devices.list.batch.tags-add-success'), 'success', 2);
            toggleSelectionMode(true); // Close the batch edit panel after operation
            $scope.paginator.reload();
          }, (err) => {
            $scope.loading = false;
            resetBatchEditFormValues();
            utils.handleApiError(err);
            toggleSelectionMode(true); // Close the batch edit panel after operation
            $scope.paginator.reload();
          });
      } else {
        $scope.loading = false;
      }
    }

    function resetBatchEditFormValues() {
      $scope.selectedDevices = [];
      $scope.selectedTagsForBatchEdit = undefined;
      $scope.selectedTagsForBatchEditObj = undefined;
    }

    // #endregion

  }
}

export default angular
  .module('main.devicesList.controller', [])
  .controller('DevicesListController', DevicesListController)
  .name;
